module.exports = __webpack_public_path__ + "static/media/drumstick.a23476d6.svg";